// extracted by mini-css-extract-plugin
module.exports = {"social_links":"Social_social_links__EES9r"};